<template>
    <section class="image-upload">

        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
                <span> Image Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
                <vs-input v-validate="'required'" data-vv-as="Image Name" type="text" class="w-full" name="file_name"
                    v-model="file_name" />

            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('file_name')">{{
                errors.first("file_name")
            }}</span>

        </div>


        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
                <span> Image:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
                <vs-input @change="uploadImage" ref="image" type="file" class="w-full" name="image" v-model="image" />
            </div>
            <vs-button class="mr-3 mb-2" @click.prevent="triggerChangeOnImagesInput">Upload</vs-button>
        </div>
    </section>
</template>

<script>
var selected_image = null
import axios from "@/axios.js";
import defineAbilitiesFor from '@/config/abilities'
export default {
    name: "ImageUpload",
    data() {
        return {
            image: null,
            file_name: null,
            uploaded_image_file_name: null,
            user_id: null,
            image_upload: {
                image_name: null,
                user_id: null,
                image: null
            }
        }
    },
    created() {

        var self = this
        defineAbilitiesFor().then(function (data) {
            self.abilities = data
        });

        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.user_id = userInfo["uid"];
        this.user_role = userInfo["userRole"];

    },
    methods: {

        triggerChangeOnImagesInput() {
            let self = this
            self.$vs.loading();



            if (selected_image && self.file_name) {


                let axois_url =
                    self.$base_url + "/api/campaigns/upload-images";
                let formData = new FormData();
                formData.append("file", selected_image);
                axios
                    .post(axois_url, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(response => {

                        if (response.data.status == "success") {
                            self.uploaded_image_file_name = response.data.data



                            if (self.uploaded_image_file_name) {
                                self.$validator.validateAll().then(result => {

                                    if (!selected_image) {
                                        result = false
                                    }

                                    if (result) {



                                        self.image_upload.image_name = self.file_name
                                        self.image_upload.user_id = self.user_id
                                        self.image_upload.image = self.uploaded_image_file_name



                                        self.$store
                                            .dispatch("campaignsManagement/addUploadedImage", self.image_upload)
                                            .then(res => {
                                                if (res.data.status == "success") {
                                                    this.$vs.notify({
                                                        color: "success",
                                                        title: "Image Upload",
                                                        text: res.data.message
                                                    });


                                                    location.reload()

                                                } else {
                                                    this.$vs.notify({
                                                        color: "danger",
                                                        title: "Image Upload",
                                                        text: res.data.message
                                                    });
                                                }

                                                self.$vs.loading.close();

                                            })
                                            .catch(err => {
                                                if (err.response.status === 401) {
                                                    self.$router.replace("/login");
                                                }
                                            })



                                    }






                                })
                            }


                        }
                    })
                    .catch(function (e) {
                        var errorMessage = (e.response && e.response.data && e.response.data.message)
                            ? e.response.data.message
                            : (e.message || 'Upload failed. Please try again.');
                        console.log(errorMessage);

                        self.$vs.notify({
                            color: "danger",
                            title: "Image Upload",
                            text: errorMessage
                        });

                        self.$vs.loading.close();
                    });




            }












        },
        uploadImage(e) {


            const files = e.target.files;
            const ImageFile = files[0];

            if (!ImageFile) return;
            if (
                ImageFile.type != "image/jpeg" &&
                ImageFile.type != "image/png" &&
                ImageFile.type !=
                "image/gif" &&
                ImageFile.type != "image/webp"
            ) {
                this.$vs.notify({
                    color: "danger",
                    title: "Invalid File",
                    text:
                        "The Image Must Be A File Of Type: JPEG, PNG , GIF , WEBP."
                });
                return;
            }
            selected_image = ImageFile

        }
    }
}
</script>

<style scoped></style>